module.exports = __webpack_public_path__ + "img/BL.55df0a2e.svg";